




















































import {defineComponent, PropType} from "@vue/composition-api";
import {email, maxLength, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import useFormHelper from "@tool/Helpers/useFormHelper";
import FormSection from "@tool/Components/FormSection.vue";
import FormError from "@tool/Components/FormError.vue";
import InputErrors from "@tool/Components/InputErrors.vue";
import useAxios from "@tool/Helpers/useAxios";
import {validateState} from "@base/base.helpers";
import {useInertia} from "@tool/Helpers/useInertia";
import {useToast} from "vue-toastification/composition";

export default defineComponent({
    components: {
        FormSection,
        FormError,
        InputErrors
    },

    props: {
        user: {
            type: Object as PropType<{
                name_first: string;
                name_last: string;
                email: string;
            }>,
            required: true
        }
    },

    setup(props) {
        const toast = useToast();

        const form = useFormHelper({
            name_first: props.user.name_first,
            name_last: props.user.name_last,
            email: props.user.email
        }, {
            name_first: 'First Name',
            name_last: 'Last Name',
            email: 'Email'
        });

        const formValidator = useVuelidate({
                    name_first: {
                        required,
                        maxLength: maxLength(255)
                    },
                    name_last: {
                        required,
                        maxLength: maxLength(255)
                    },
                    email: {
                        required,
                        email,
                        maxLength: maxLength(255),
                    }
                },
                form.value.data
        );

        /**
         * In case last name is empty
         */
        formValidator.value.$touch();

        const formHandle = () => {
            form.value.submit((data) => {
                return useAxios().put<{
                    name_first: string;
                    name_last: string;
                    email: string;
                }>(route('app.settings.profile.update-profile-info'), {
                    name_first: data.name_first,
                    name_last: data.name_last,
                    email: data.email
                });
            }).then(response => {
                if (response.success) {
                    useInertia().get(route(route().current(), route().params), {}, {
                        preserveScroll: true,
                        onSuccess() {
                            toast.success('Your profile information was updated!');
                        }
                    });
                }
            })
        };

        return {
            form,
            formHandle,
            formValidator,
            validateState,
        }
    }
});
